import React from 'react';

const Projects = ({ projects }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-100">
      <div className="bg-green-50 px-6 py-3 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center">
          Projects <span className="ml-2 text-sm font-normal text-gray-600">(extracted from resume)</span>
        </h3>
      </div>
      <div className="px-6 py-5">
        {projects?.items && 
         (Array.isArray(projects.items) ? 
          projects.items.length > 0 : true) ? (
          <div className="space-y-8">
            {Array.isArray(projects.items) ? (
              projects.items.map((project, index) => (
                <div key={index} className="border-b border-gray-100 pb-6 last:border-b-0 last:pb-0">
                  <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-3">
                    <div>
                      <div className="flex flex-row items-center">
                        <h4 className="text-md font-bold text-gray-900">{project.projectName}</h4>
                        {project.isOpenSource && project.isOpenSource?.toString().toLowerCase() === 'yes' && (
                          <div className="text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded-full font-medium ml-2">
                            Open Source
                          </div>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 mt-1">
                        Organization: {project.organisationName || "N/A"}
                      </p>
                    </div>
                    <div className="mt-1 md:mt-0">
                      <div className="text-sm bg-green-50 text-green-700 px-3 py-1 rounded-full font-medium">
                        {project.projectRole}
                      </div>
                    </div>
                  </div>
                  {project.projectDescription && (
                    <p className="text-gray-700 mb-4 leading-relaxed">{project.projectDescription}</p>
                  )}
                  {project.projectDetails && (
                    (Array.isArray(project.projectDetails) ? project.projectDetails.length > 0 : project.projectDetails.trim().length > 0)
                  ) && (
                    <div className="mb-4">
                      <h5 className="text-sm font-semibold text-gray-700 mb-2">Project Details:</h5>
                      {Array.isArray(project.projectDetails) ? (
                        <ul className="list-disc list-outside text-gray-600 text-sm pl-5 space-y-1">
                          {project.projectDetails.map((detail, idx) => (
                            <li key={idx} className="leading-relaxed">{detail}</li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-gray-600 text-sm leading-relaxed">{project.projectDetails}</p>
                      )}
                    </div>
                  )}
                  {project.skillsUsed && project.skillsUsed.length > 0 && (
                    <div className="mb-4">
                      <h5 className="text-sm font-semibold text-gray-700 mb-2">Skills Used:</h5>
                      <div className="flex flex-wrap gap-2">
                        {project.skillsUsed.map((skill, idx) => (
                          <span key={idx} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium">
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                  {project.links && project.links.length > 0 && (
                    <div>
                      <h5 className="text-sm font-semibold text-gray-700 mb-2">Project Links:</h5>
                      <ul className="list-disc list-inside text-blue-600 text-sm pl-2">
                        {project.links.map((link, idx) => (
                          <li key={idx}>
                            <a 
                              href={link.startsWith('http') ? link : `https://${link}`} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="hover:underline"
                            >
                              {link}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="border-b border-gray-100 pb-6">
                <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-3">
                  <div>
                    <div className="flex flex-row items-center">
                      <h4 className="text-md font-bold text-gray-900">
                        {projects.items.projectName}
                      </h4>
                      {projects.items.isOpenSource && 
                        projects.items.isOpenSource?.toString().toLowerCase() === 'yes' && (
                        <div className="text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded-full font-medium ml-2">
                          Open Source
                        </div>
                      )}
                    </div>
                    <p className="text-sm text-gray-600 mt-1">
                      Organization: {projects.items.organisationName || "N/A"}
                    </p>
                  </div>
                  <div className="mt-1 md:mt-0">
                    <div className="text-sm bg-green-50 text-green-700 px-3 py-1 rounded-full font-medium">
                      {projects.items.projectRole}
                    </div>
                  </div>
                </div>
                {projects.items.projectDescription && (
                  <p className="text-gray-700 mb-4 leading-relaxed">{projects.items.projectDescription}</p>
                )}
                {projects.items.projectDetails && (
                  (Array.isArray(projects.items.projectDetails) ? projects.items.projectDetails.length > 0 : projects.items.projectDetails.trim().length > 0)
                ) && (
                  <div className="mb-4">
                    <h5 className="text-sm font-semibold text-gray-700 mb-2">Project Details:</h5>
                    {Array.isArray(projects.items.projectDetails) ? (
                      <ul className="list-disc list-outside text-gray-600 text-sm pl-5 space-y-1">
                        {projects.items.projectDetails.map((detail, idx) => (
                          <li key={idx} className="leading-relaxed">{detail}</li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-gray-600 text-sm leading-relaxed">{projects.items.projectDetails}</p>
                    )}
                  </div>
                )}
                {projects.items.skillsUsed && 
                 projects.items.skillsUsed.length > 0 && (
                  <div className="mb-4">
                    <h5 className="text-sm font-semibold text-gray-700 mb-2">Skills Used:</h5>
                    <div className="flex flex-wrap gap-2">
                      {projects.items.skillsUsed.map((skill, idx) => (
                        <span key={idx} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {projects.items.links && 
                 projects.items.links.length > 0 && (
                  <div>
                    <h5 className="text-sm font-semibold text-gray-700 mb-2">Project Links:</h5>
                    <ul className="list-disc list-inside text-blue-600 text-sm pl-2">
                      {projects.items.links.map((link, idx) => (
                        <li key={idx}>
                          <a 
                            href={link.startsWith('http') ? link : `https://${link}`} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="hover:underline"
                          >
                            {link}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="py-8 text-center">
            <p className="text-gray-500 italic">The candidate has not listed any projects.</p>
            <p className="text-gray-400 text-sm mt-2">Projects will appear here when available.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
